const { createSlice } = require("@reduxjs/toolkit");

const sidebarSlice=createSlice({
    name:'sidebar',
    initialState:{
        showSidebar:true,
        route:'/'
    },
    reducers:{
        setSidebar(state,action){
            state.showSidebar=action.payload
        },
        setRoute(state,action){
            state.route=action.payload
        }
    }
})

export const sidebarActions=sidebarSlice.actions;
export default sidebarSlice;